import _objectSpread from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _typeof from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _regeneratorRuntime from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import KivaProxy from "@/utils/kivaProxy/src";
import optionsMixin from "@/mixins/options";
export default {
  props: {
    value: {
      type: [Object, Number, Array, String, Boolean],
      default: function _default() {
        return {
          value: null
        };
      }
    },
    account: [Object, Number],
    size: {
      type: String,
      default: "medium"
    },
    extendedClass: {
      type: String,
      default: ""
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: false
    },
    focus: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      mutableValue: this.value,
      accountLoading: false,
      startLoading: "startLoading",
      list: [],
      mainKey: Math.random(9, 99999999999999),
      listOriginal: [],
      starredProjects: [],
      starredProjectsList: [],
      uniq: new Date().getUTCMilliseconds(),
      counter: {
        duration: 300,
        interval: null
      }
    };
  },
  mixins: [optionsMixin],
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.setValue();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    onPageChange: function onPageChange(event) {
      this.pagination.limit = event.currentPerPage;
      this.pagination.page = event.currentPage;
      this.$emit("setPagination", this.pagination);
    },
    onPerPageChange: function onPerPageChange(event) {
      // console.log("event", event);
      this.pagination.limit = event.currentPerPage;
      this.pagination.page = event.currentPage;
      this.$emit("setPagination", this.pagination);
    },
    selectionChanged: function selectionChanged(selection) {
      // console.log("selection", selection);
    },
    visibleSolution: function visibleSolution(row, status, forceStatus) {
      this.$emit("visibleSolution", {
        row: row,
        status: status,
        forceStatus: forceStatus
      });
    },
    startInterval: function startInterval(query) {
      var _this2 = this;
      if (this.counter.interval) {
        clearInterval(this.counter.interval);
      }
      this.counter.interval = setInterval(function () {
        _this2.getLists(query);
        clearInterval(_this2.counter.interval);
      }, this.counter.duration);
    },
    setValue: function setValue() {
      var _this3 = this;
      this.accountLoading = true;
      this.list = [];

      /// GET SELECTED PROJECT
      if (this.value && _typeof(this.value) == 'object') {
        Object.assign(this.mutableValue, this.value);
      }
      // if (typeof this.value == "Object" && this.value && this.value.value) {
      //   Object.assign(this.mutableValue, this.value);
      // } else if (typeof this.value == "Object" && this.value[0] && this.value[0].value) {
      //   Object.assign(this.mutableValue, this.value);
      // }

      // console.log("this.value", this.value);
      if (this.value && this.value.value && this.value.label) {
        this.listOriginal = [{
          record_id: this.value.value,
          value: this.value.value,
          project_name: this.value.label
        }];
        if (!this.list.find(function (k) {
          return _this3.value.value == k.record_id;
        })) {
          this.list.push(this.listOriginal[0]);
        }
        setTimeout(function () {
          _this3.accountLoading = false;
        }, 200);

        // console.log(this.list,this.listOriginal[0])
      } else if (typeof this.value == "number" || this.value && this.value.value && !this.value.label) {
        var vl = this.value && this.value.value ? this.value.value : this.value ? this.value : null;
        vl = vl + "";
        vl = vl ? vl.replace("undefined", "") : "";
        this.accountLoading = true;
        new KivaProxy({
          endpoint: "act/project"
        }).setFields(["record_id", "avatar_image", "approval_required", "account_name", "project_color", "project_name", "project_status", "project_group", "start_date", "description", "due_date", "follow_up_on", "record_owner", "team", "use_threads", "approval_required", "use_sections", "section_required", "time"]).find(vl).then(function (response) {
          _this3.accountLoading = false;
          response.record.value = response.record.record_id;
          response.record.label = response.record.project_name;
          if (!_this3.list.find(function (k) {
            return response.record.value == k.record_id;
          })) {
            _this3.list.push(response.record);
          }
        }).catch(function (err) {
          _this3.accountLoading = false;
        });
      } else if (typeof this.value == "number" || this.value && this.value[0]) {
        var _vl = this.value && this.value[0] ? this.value[0] && this.value[0].record_id ? this.value[0].record_id : this.value[0] : 0;
        this.accountLoading = true;
        _vl = _vl + "";
        _vl = _vl ? _vl.replace("undefined", "") : "";
        new KivaProxy({
          endpoint: "act/project"
        }).setFields(["record_id", "avatar_image", "approval_required", "account_name", "project_color", "project_name", "project_status", "project_group", "start_date", "description", "due_date", "follow_up_on", "record_owner", "team", "use_threads", "approval_required", "use_sections", "section_required", "time"]).find(_vl).then(function (response) {
          _this3.accountLoading = false;
          response.record.value = response.record.record_id;
          if (!_this3.list.find(function (k) {
            return response.record.value == k.record_id;
          })) {
            _this3.list.push(response.record);
          }
        }).catch(function (err) {
          _this3.accountLoading = false;
        });
      } else {
        // console.log("this.value 4");
        this.getLists();
        this.list = this.listOriginal;
      }
      setTimeout(function () {
        _this3.key = "false" + Math.random(99, 999999999);
        _this3.accountLoading = false;
      }, 400);
    },
    getLists: function getLists(query, filter) {
      var _this4 = this;
      if (query && query.length > 2 || this.account && this.account.value) {
        this.accountLoading = true;
        var accountSearch = {};
        if (this.account && this.account.value) {
          accountSearch = {
            account_name: ["=", this.account.value]
          };
        }
        var search = JSON.stringify(accountSearch);
        var limit = filter && filter.limit > 0 ? parseInt(filter.limit) : 100;
        new KivaProxy({
          endpoint: "act/project"
        }).setFields(["record_id", "avatar_image", "approval_required", "account_name", "project_color", "project_name", "project_status", "project_group", "start_date", "description", "due_date", "follow_up_on", "record_owner", "team", "use_threads", "approval_required", "use_sections", "section_required", "time_entry_required"]).setFilters(search).setKeyword(query).setLimit(limit).setSort("project_name").setDir("ASC").all().then(function (response) {
          _this4.list = response.records;
          _this4.list.forEach(function (k) {
            k.value = k.record_id;
          });
          _this4.listOriginal.forEach(function (kk) {
            if (!_this4.list.find(function (k) {
              return kk.record_id == k.record_id;
            })) {
              _this4.list.push(kk);
            }
          });
          //  console.log("1 this.list", this.list)
          _this4.accountLoading = false;
        }).catch(function (err) {
          _this4.list = _this4.listOriginal;
          _this4.accountLoading = false;
        });
      } else {
        // this.accountLoading = true;
        this.getListsStarred();
        this.listOriginal.forEach(function (kk) {
          _this4.list.push(kk);
        });
        this.accountLoading = false;
        this.key = "false" + Math.random(99, 999999999);
        this.accountLoading = false;
      }
    },
    getListsStarred: function getListsStarred() {
      this.accountLoading = true;
      // console.log("this.starred_projects",this.starred_projects)
      if (this.starred_projects) {
        this.listOriginal = this.starred_projects.map(function (a) {
          a.value = a.project_id;
          a.label = a.project_name;
          return a;
        });
      }
      this.accountLoading = false;
    }
  },
  computed: {
    starred: function starred() {
      var starredProjects = window.localStorage.getItem("starred");
      return JSON.parse(starredProjects);
    },
    starred_projects: function starred_projects() {
      return this.$store.state.project.STARRED_PROJECTS;
    }
  },
  watch: {
    focus: function focus(val) {
      if (val) {
        this.$refs.extendedClass.input.focus();
      }
    },
    mutableValue: function mutableValue(val) {
      if (this.isMultiple) {
        this.$emit("input", val);
      } else {
        this.$emit("input", {
          value: val.record_id,
          label: val.project_name
        });
        this.$emit("allData", _objectSpread({}, val));
        if (val && val.account_name && val.account_name.value) {
          this.$emit("setAccount", {
            value: val.account_name.value,
            label: val.account_name.label
          });
        }
      }
    },
    // "mutableValue.value"(val) {
    //   this.$emit("input", { value: val });
    //   if (
    //     this.mutableValue &&
    //     this.mutableValue.account_name &&
    //     this.mutableValue.account_name.value
    //   ) {
    //     this.$emit("setAccount", {
    //       value: this.mutableValue.account_name.value,
    //       label: this.mutableValue.account_name.label,
    //     });
    //   }
    // },
    // value(val) {
    //   this.setValue();
    // },
    "value.value": function valueValue(val) {
      this.setValue();
    },
    account: function account(val) {
      this.getLists("");
    }
  }
};